import { useCreateAppRouter } from "@/hooks/use-create-app-router";
import { RouterProvider } from "react-router-dom";

function AppRouter() {
  return <RouterProvider router={useCreateAppRouter()} />;
}

export default AppRouter;
